import {
  Component,
  ElementRef,
  Input,
  inject,
  OnInit,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core'
import { CatalogueEntry, CatalogueService, Field, RootStoreState, StoredEntityService } from '@dot-it/jml-lib'
import { Observable, of } from 'rxjs'
import { filter, map, switchMap, tap } from 'rxjs/operators'
import { EntityReference } from '../../../../models/entity-reference'
import { select, Store } from '@ngrx/store'
import * as fromConfigSelectors from '../../../../../../root-store/config-store/config.selectors'

interface MinimalCatalogueEntry {
  id: number
  name: string
}

@Component({
  selector: 'jml-lib-dtotype-cell',
  templateUrl: './dtotype-cell.component.html',
  styleUrls: ['./dtotype-cell.component.scss']
})
/**
 * WrapperComponent for a dtoType drop down cell.
 */
export class DtoTypeCellComponent implements OnInit, OnChanges {
  @Input() tableReference: ElementRef
  @Input() editable = false

  // rowData[field.field] is expected to contain the name of the selected dtoType
  @Input() rowData: any
  @Input() field: Field
  @Input() customEdit = false

  @Output() completeCellEdit: EventEmitter<any> = new EventEmitter()
  @Output() onCustomEdit: EventEmitter<any> = new EventEmitter()

  options$: Observable<MinimalCatalogueEntry[]>

  // as the passed value is a string, we need to artificially word with a structure {id: number, name: <actual value>} for the drop down cell.
  // here we store the transformed input value
  selectedValueAsCatalogueEntry: MinimalCatalogueEntry | undefined
  catalogueEntries: MinimalCatalogueEntry[]

  private store$ = inject(Store<RootStoreState.State>)

  ngOnInit(): void {
    // get all dtoConfigs for field.type === 'dtoType' (e.g. for Script Actions)
    const configurations$ = this.store$.pipe(select(fromConfigSelectors.selectConfigs))
    const dtoType = this.rowData[this.field.field]

    this.options$ = configurations$.pipe(
      filter((configs) => !!configs),
      map((configs) =>
        Object.values(configs).map((config, idx) => {
          // construct something like "minimum Catalogue Entry"
          return { id: idx + 1, name: config['type'] }
        })
      ),
      tap((catalogueEntries) => {
        this.catalogueEntries = catalogueEntries
        this.setSelectedValue(dtoType)
      })
    )
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.rowData && !changes.rowData.firstChange) {
      this.setSelectedValue(this.rowData[this.field.field])
    }
  }

  setSelectedValue(dtoType: string) {
    this.selectedValueAsCatalogueEntry = this.catalogueEntries?.find((ce) => ce.name === dtoType)
  }

  emitComplete(event: any) {
    // we need to return the name of the selected entry
    // the returned value is the selected MinimalCatalogueEntry
    this.completeCellEdit.emit({ value: event.value?.name ?? null })
  }

  emitOnCustomEdit() {
    this.onCustomEdit.emit()
  }
}
